export function SwitchSlider(container, SwitchSlides) {
  let currentIndex = 0
  const isSlider = container.classList.contains('b-doctor-details_slider')

  if (!isSlider) {
    return
  }

  const allWrappers = container.querySelectorAll('.b-doctor-details__body')
  const allContainers = container.querySelectorAll('.b-doctor-details__content')
  const allContainersButton = container.querySelectorAll('.b-doctor-details__more-btn-container')

  if (!allWrappers.length) {
    return
  }

  for (let i = 0; i < allContainersButton.length; i++) {
    const wrapperHeight = allWrappers[i].offsetHeight
    const containerHeight = allContainers[i].offsetHeight

    if (wrapperHeight < containerHeight) {
      allContainersButton[i].classList.remove('b-doctor-details__more-btn-container_hidden')
    }
  }

  $(container).on('translated.owl.carousel', event => {
    if (currentIndex === event.item.index) {
      return
    }

    currentIndex = event.item.index

    Array.from(event.currentTarget.querySelectorAll('.b-doctor-details__more-btn')).forEach(button => SwitchSlides.remove(button))
  })
}
